<template>
  <div>
    <div class="d-flex align-center column-gap-2">
      <span v-if="item.signInOrder"
            class="mr-2"
      >
        {{ signatory.signingOrder }}.
      </span>

      <app-material-icon v-if="signatory.status !== 'signed'"
        name="schedule"
      />

      <AppTooltip v-if="signatory.status === 'signed'">
        <template #activator="{ props }">
          <app-material-icon
            name="check_circle"
            color="icon-success"
            v-bind="props"
          />
        </template>
        <span>
          {{
            $t(
              'project.project-settings.signatures.ProjectSettingsSignaturesSignatory.userSignedTooltip',
              { date: getSignatureDate(signatory) },
            )
          }}
        </span>
      </AppTooltip>

      <span>{{ signatory.fullName }}</span>

      <app-button v-if="signatory.status === 'sent'"
                  :disabled="signatoryChaseButtonIsDisabled(signatory.signatureId)"
                  :loading="signatoryChaseLoading && signatoryChaseLoading === signatory.signatureId"
                  class="ml-1 mb-1"
                  size="small"
                  type="outlined"
                  variant="neutral"
                  @click.stop="prepareChaseSignatory(item, signatory)"
      >
        {{ $t('common.chase') }}
      </app-button>
    </div>

    <div v-for="witness in witnessesList"
         :key="`witness-${witness.id}`"
         class="d-flex align-center ml-6 column-gap-1"
    >
      <span v-if="item.signInOrder">{{ witness.signingOrder }}.</span>

      <app-material-icon v-if="witness.status !== 'signed'"
        name="schedule"
      />

      <AppTooltip v-if="witness.status === 'signed'">
        <template #activator="{ props }">
          <app-material-icon
            name="check_circle"
            color="icon-success"
            v-bind="props"
          />
        </template>
        <span>
          {{
            $t(
              'project.project-settings.signatures.ProjectSettingsSignaturesSignatory.userSignedTooltip',
              { date: getSignatureDate(witness) },
            )
          }}
        </span>
      </AppTooltip>

      <span>{{ witness.fullName }}</span>

      <app-button v-if="signatory.status === 'signed' && witness.status === 'sent'"
                  :disabled="signatoryChaseButtonIsDisabled(witness.signatureId)"
                  :loading="signatoryChaseLoading && signatoryChaseLoading === witness.signatureId"
                  class="ml-1 mb-1"
                  size="small"
                  type="outlined"
                  variant="neutral"
                  @click.stop="prepareChaseSignatory(item, witness)"
      >
        {{ $t('common.chase') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { mapActions, mapState, mapGetters } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { ISOToShortDate } from '@/common/utils/dates'
import { toast } from '@/common/utils/toast'
import { CHASE_USERS } from '@/store/modules/room/action_types'
import { ADD_CHASE_TIMER_SIGNATURE } from '@/store/modules/room/mutation_types'

export default {
  name: 'ProjectSettingsSignaturesSignatory',
  props: {
    signatory: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      signatoryChaseLoading: null,
    }
  },
  components: {
    AppTooltip,
  },
  computed: {
    ...mapState('room', ['chaseTimers']),
    ...mapGetters('room', ['roomMnemo']),
    witnessesList () {
      return this.item.signatories.filter(s => s.signatureType === 'witness' && s.witnessOfSignerId === this.signatory.id)
    },
  },
  methods: {
    ...mapActions('room', [CHASE_USERS]),
    getSignatureDate (signatory) {
      return ISOToShortDate(signatory.timestamp)
    },
    async prepareChaseSignatory (envelope, signatory) {
      // TODO : Handle pendingIDS with vuex-action
      this.signatoryChaseLoading = signatory.signatureId
      try {
        await this.CHASE_USERS({
          mnemo: this.roomMnemo,
          envelopeId: envelope.id,
          data: {
            usersIds: [signatory.id],
          },
        })

        toast.success(this.$t('common.chaseSuccess'))
        this.$store.commit(`room/${ADD_CHASE_TIMER_SIGNATURE}`, signatory.signatureId)
      } catch (error) {
        console.error(error)
        toast.error(this.$t('common.chaseError'))
      } finally {
        this.signatoryChaseLoading = null
      }
    },
    signatoryChaseButtonIsDisabled (signatureId) {
      const signatureChaseTimer = this.chaseTimers.signature?.[signatureId]
      return signatureChaseTimer && dayjs().isBefore(signatureChaseTimer)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/border-tokens";

.ProjectSettingsSignatures-listDot {
  background-color: rgb(var(--v-theme-accent));
  @include border-radius('border-radius-circle');
  display: inline-block;
  height: 5px;
  margin-right: 5px;
  vertical-align: middle;
  width: 5px;
}
</style>
